import { Box } from "@mui/system";
import React from "react";
import { Logo } from "@/types/dto/common/image";
import Image from "next/image";
import { Typography } from "@mui/material";

interface LogoGridProps {
  logos: Logo[];
  parentContainerType?: string;
  moduleName?: string;
  moduleRankingPosition?: string;
  logoGridHeader?: string;
  logoHeight?: number;
  bgColor?: string;
}

const LogoGrid = ({
  logos,
  parentContainerType = "logos",
  moduleName = "Logos",
  moduleRankingPosition = "8",
  logoGridHeader,
  logoHeight = 100,
  bgColor
}: LogoGridProps) => (
  <Box
    component="section"
    className="fluid-box"
    sx={{ backgroundColor: bgColor || "" }}
    aria-label={moduleName || "logos"}
    data-testid={`${parentContainerType}-section`}
    data-track="visibility"
    data-parent-container-type={parentContainerType}
    data-module-name={moduleName}
    data-module-ranking-position={moduleRankingPosition}
  >
    <Box className="destination-page-container">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4rem",
          padding: { xs: "4rem 2.4rem", lg: "6rem 10rem" }
        }}
      >
        {logoGridHeader && (
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2.6rem", md: "2.8rem", lg: "3.2rem" },
              textAlign: "center",
              lineHeight: "150%"
            }}
            data-testid={`${parentContainerType}-header`}
          >
            {logoGridHeader}
          </Typography>
        )}
        <Box
          component="ul"
          data-testid={`${parentContainerType}-list`}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            rowGap: "10px",
            columnGap: "40px",
            maxWidth: "900px",
            justifySelf: "center",
            margin: "0 auto",
            listStyle: "none",
            padding: "0rem"
          }}
        >
          {logos.map((item, index) =>
            item.imageUrl ? (
              <Box
                component="li"
                key={item.id}
                data-testid={`${parentContainerType}-${index}`}
                sx={{ maxWidth: "180px" }}
              >
                <Image
                  width={180}
                  height={logoHeight}
                  src={item.imageUrl}
                  alt={item.altText || `${moduleName} ${index + 1}`}
                  data-testid={`${parentContainerType}-image-${index}`}
                  style={{ objectFit: "contain" }}
                />
              </Box>
            ) : null
          )}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default LogoGrid;
